<template>
    <Head title="Home"/>

    <div class="relative flex flex-col min-h-screen bg-gray-100 dark:bg-gray-900">
        <div class="flex flex-row justify-between">
            <div class="px-6 py-4">
                <span class="text-gray-300 font-bold">BETA</span>
            </div>
            <div class="px-6 py-4">
                <Link v-if="$page.props.auth.user" href="/dashboard" class="text-sm text-gray-700 underline">
                    Dashboard
                </Link>

                <template v-else>
                    <Link :href="route('login')" class="text-sm text-gray-700 underline">
                        Log in
                    </Link>

                    <Link :href="route('register')" class="ml-4 text-sm text-gray-700 underline">
                        Register
                    </Link>
                </template>
            </div>
        </div>
        <div class="max-w-6xl mx-auto sm:px-6 lg:px-8">
            <div class="flex justify-center pt-8 sm:justify-start sm:pt-0">
                <img src="../../../assets/logo.png" alt="logo"/>
            </div>
            <div class="mt-8 flex flex-row justify-between">
                <h1 class="text-3xl font-semibold text-gray-900">Featured Levels</h1>
                <input placeholder="Search a level..." type="text" class="text-sm text-gray-400 p-3 bg-white dark:bg-gray-800 shadow sm:rounded-lg border-none focus:outline-none focus:border-transparent focus:ring-transparent"/>
            </div>
            <div class="mt-4 bg-white dark:bg-gray-800 overflow-hidden shadow sm:rounded-lg">
                <div class="p-6">
                    <div class="flex items-center">
                        <div class="ml-4 text-lg leading-7 font-semibold">
                            <a href="https://laravel.com/docs" class="underline text-gray-900 dark:text-white">Documentation</a>
                        </div>
                    </div>
                    <div class="ml-12">
                        <div class="mt-2 text-gray-600 dark:text-gray-400 text-sm">
                            Laravel has wonderful, thorough documentation covering every aspect of the framework.
                            Whether you are new to the framework or have previous experience with Laravel, we recommend
                            reading all of the documentation from beginning to end.
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex justify-center mt-4 sm:items-center sm:justify-between">
                <div class="text-center text-sm text-gray-500 sm:text-left">
                    <div class="flex items-center">
                        Crafted with
                        <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                             stroke-width="2" viewBox="0 0 24 24" class="mx-1 -mt-px w-4 h-4 text-red-500">
                            <path
                                d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"></path>
                        </svg>
                        By
                        <a href="https://bird.cafe" class="ml-1 underline">
                            Bird Cafe
                        </a>
                    </div>
                </div>

                <div class="ml-4 text-center text-sm text-gray-500 sm:text-right sm:ml-0">
                    Not affiliated with Studio Bean
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {Head, Link} from '@inertiajs/inertia-vue3';

export default {
    components: {
        Head,
        Link,
    },
    props: {
        levels: Array,
    },
}
</script>
